//Componentes generales
import React, { useContext, useReducer } from "react";
import reqsSectorsReducer from "./reqsSectorsReducer.js";
import reqsSectorsContext from "./reqsSectorsContext.js";

//Socket
import { SocketContext } from "../socket/socket";

//Axios
import clienteAxios from "../../config/axios.js";

//Rutas de api
import { getAbmReqSector, uploadAbmReqSector } from "../../api/abmReqSector.js"

//Acciones
import { 
    ACTUALIZAR_SECTORES_REQS,
    ACTUALIZAR_SECTORES_REQS_LIST,
    ACTUALIZAR_SECTORES_REQS_DB,
    CARGANDO_SECTORES_REQS,
    ERROR_SECTORES_REQS,
    LIMPIAR_ERROR
} from "./reqsSectorsAction.js";

/* 
    State encargado de la gestión de sectores de requerimiento.
*/
const ReqsSectorsState = props => {

    const server = useContext(SocketContext);

    //Valores iniciales
    const initialState = {
        reqsSectors: [],
        reqsSectorsList: [],
        cargando: false,
        error: ""
    };

    const [state, dispatch] = useReducer(reqsSectorsReducer, initialState);

    /* 
        Función recuperar los sectores de requerimientos y a su vez actualizarlos.
    */
    const actualizarReqsSectors = async () => {

        try{
            const resp = await getAbmReqSector();

            dispatch({
                type: ACTUALIZAR_SECTORES_REQS,
                payload: resp.data.data
            })

            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    /* Función para recuperar los sectores de requerimientos y actualizar la lista de sectores de requerimientos */
    const actualizarReqsSectorsList = async () => {

        try{
            const resp = await getAbmReqSector();

            dispatch({
                type: ACTUALIZAR_SECTORES_REQS_LIST,
                payload: resp.data.data
            })

            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    /* 
        Función encargada de sobreescribir la base de datos de sectores de requerimientos con la propia de Softland.
            Donde userID es el ID del usuario en sesión.
                  userName es el nombre del usuario en sesión.
    */
    const actualizarReqsSectorsDB = async () => {

        try{
            console.log("ENTRO AL ACTUALIZAR SECTORES DE REQUERIMIENTOS");
            // El endpoint solo confirma que el proceso arrancó en segundo plano;
            // hay que esperar el aviso por socket para saber el resultado real.
            await uploadAbmReqSector();

            if (!server) {
                throw new Error("No hay conexión en tiempo real disponible. Recargue la página e intente nuevamente.");
            }

            const resultado = await new Promise((resolve) => {
                server.once("actualizarAbmReqSectorFinalizado", resolve);
            });

            if (resultado.status !== 200) {
                dispatch({
                    type: ERROR_SECTORES_REQS,
                    payload: resultado.message
                });
                return {status: false, msg: resultado.message};
            }

            const resp = await getAbmReqSector();
            console.log(resp);
            dispatch({
                type: ACTUALIZAR_SECTORES_REQS_DB,
                payload: resp.data.data
            });

        return {status: true, msg: "Se actualizo con exito la base de datos."};

        }catch(error){
            console.log(error);
            const errMsg = error.response?.data?.errMsg || error.response?.data?.message || error.message || 'Error desconocido';
            dispatch({
                type: ERROR_SECTORES_REQS,
                payload: errMsg
            });

            return {status: false, msg: errMsg};
        }
    }

    const cargando =  () => {
        dispatch({
            type: CARGANDO_SECTORES_REQS
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    return(
        <reqsSectorsContext.Provider
            value={{
                reqsSectors: state.reqsSectors,
                reqsSectorsList: state.reqsSectorsList,
                isCargando: state.cargando,
                error: state.error,
                actualizarReqsSectors,
                actualizarReqsSectorsList,
                actualizarReqsSectorsDB,
                cargando,
                limpiarError
            }}
        >

            {props.children}

        </reqsSectorsContext.Provider>
    )
    
}

export default ReqsSectorsState;